import React from 'react';
import { useSelector } from 'react-redux';

import REDUX_ZasedaniyaPravleniyaFederatsii from '../../objects/ZasedaniyaPravleniyaFederatsii/reducer'
import REDUX_Pari from '../../objects/Pari/reducer';
import { getChlenFederatsiiFromRoles, getKollektivFromRoles, getOrganizatorFromRoles, getParaFromRoles, getPrepodavatelFromRoles, getShkolaFromRoles, getSudyaFromRoles, getTantsorFromRoles } from '../Tool';

var _ = require('lodash');

export const unwrap = (value, element) => {
	if (_.isFunction(value) == true) {
		return unwrap(value());
	} else if (_.isArray(value)) {
		return value
	}
	return (!element) ? [value] : value;
};
// Если все переданные аргументы не false/undefined/null/0
export const If = (equations, truthful) => {
	return (And(equations) === true) ? unwrap(truthful, true) : undefined;
};
export const IfElse = (equations, truthful, untruthful) => {
	return (And(equations) === true) ? unwrap(truthful, true) : unwrap(untruthful, true);
};
// Логическое И всех переданных аргументов
export const And = (args) => {
	var acc = true;
	let unwraped = unwrap(args);
	for (let i = 0; i < unwraped?.length; i++) {
		const element = unwraped[i];
		acc = acc && element;
		if (!acc) break;
	}
	return acc;
};
// Логическое ИЛИ всех переданных аргументов
export const Or = (args) => {
	var acc = true;
	let unwraped = unwrap(args);
	for (let i = 0; i < unwraped?.length; i++) {
		const element = unwraped[i];
		acc = acc || element;
	}
	return acc;
};


// Работа с объектами всех типов пользователей по проверке документов
const WaitingEntrance = () => { }; // Есть заявление на вступление, ожидающее решения
const WaitingAbandon = () => { }; // Есть заявление на выход, ожидающее решения

export function IFTrue(type, returnIfTrue, object, {
	chlenFederatsii,
	tantsor,
	shkola,
	para,
	kollektiv,
	prepodavatel,
	sudya,
	organizator,
	pari,
	zasedanie
}) {

	const zayavlenienachlenstvovfederatsii = () => {
		// If(!chlenFederatsii?.length, true)
		return !chlenFederatsii?.length;
	};
	const not_zayavlenienachlenstvovfederatsii = () => {
		return chlenFederatsii?.length > 0;
	};
	const samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii = () => {
		return chlenFederatsii?.filter(item =>
			item.dokumentVstupleniyaID &&
			!item.dokumentVikhodaIzFederatsiiID &&
			!item.dokumentOtFederatsiiDlyaRassmotreniyaNaVikhodID &&
			!item.zayavlenieOtChlenaFederatsiiNaVikhodID)?.length > 0;
	};
	const novoezasedaniepravleniyafederatsii = () => {
		return true;
	};
	const vpdnovieotdeleniyachleniiliisklyuchenie = () => {
		return object &&
			!object?.dataOkonchaniyaZasedaniya &&
			!object?.dataNachalaZasedaniya &&
			!object?.dataNachalaRegistratsiiUchastnikov
	};
	const vpdzasedaniyapravleniyafederatsiitekst = () => {
		return object &&
			!object?.dataOkonchaniyaZasedaniya &&
			!object?.dataNachalaZasedaniya &&
			!object?.dataNachalaRegistratsiiUchastnikov;
	};
	const otkritieregistratsiinazasedaniepravleniyafederatsii = () => {
		return object &&
			!object?.dataOkonchaniyaZasedaniya &&
			!object?.dataNachalaZasedaniya &&
			!object?.dataNachalaRegistratsiiUchastnikov;
	};
	const dokumentprisutstvuyushchienazasedaniipravleniyafederatsii = () => {
		return object &&
			!!object?.dataNachalaRegistratsiiUchastnikov &&
			!object?.dataOkonchaniyaZasedaniya &&
			!object?.dataNachalaZasedaniya;
	};
	const otkritiezasedaniyapravleniyafederatsii = () => {
		return object &&
			!object?.dataOkonchaniyaZasedaniya &&
			!object?.dataNachalaZasedaniya &&
			!!object?.dataNachalaRegistratsiiUchastnikov;
	};
	const resheniepovoprosupovestkidnyazasedaniyapravleniyafederatsii = () => {
		return object &&
			!object?.dataOkonchaniyaZasedaniya &&
			!!object?.dataNachalaZasedaniya;
	};
	const zakritiezasedaniyapravleniyafederatsii = () => {
		return object &&
			!object?.dataOkonchaniyaZasedaniya &&
			!!object?.dataNachalaZasedaniya;
	};
	const samostoyatelnayaregistratsiyatantsorafederatsii = () => {
		return !tantsor?.length;
	};
	const not_samostoyatelnayaregistratsiyatantsorafederatsii = () => {
		return tantsor?.length > 0;
	};
	const samostoyatelnayaregistratsiyasudifederatsii = () => {
		return !sudya?.length;
	};
	const not_samostoyatelnayaregistratsiyasudifederatsii = () => {
		return sudya?.length > 0;
	};

	const samostoyatelnayaregistratsiyaprepodavatelyafederatsii = () => {
		return !prepodavatel?.length;
	};
	const not_samostoyatelnayaregistratsiyaprepodavatelyafederatsii = () => {
		return prepodavatel?.length > 0;
	};
	const samostoyatelnayaregistratsiyaorganizatora = () => {
		return !organizator?.length;
	};
	const not_samostoyatelnayaregistratsiyaorganizatora = () => {
		return organizator?.length > 0;
	};
	const samostoyatelnayaregistratsiyashkolifederatsii = () => {
		return !shkola?.length;
	};
	const not_samostoyatelnayaregistratsiyashkolifederatsii = () => {
		return shkola?.length > 0;
	};
	const samostoyatelnayaregistratsiyakollektivafederatsii = () => {
		return !kollektiv?.length;
	};
	const not_samostoyatelnayaregistratsiyakollektivafederatsii = () => {
		return kollektiv?.length > 0;
	};
	const novoezasedanieregionalnogopravleniya = () => {
		return true;
	};
	const vpdnoviepotrebiteliiliisklyuchenie = () => {
		return object &&
			!object.dataOkonchaniyaZasedaniya &&
			!object.dataNachalaZasedaniya &&
			!object.dataNachalaRegistratsiiUchastnikov;
	};
	const vpdzasedaniyaregpravleniyatekst = () => {
		return object &&
			!object.dataOkonchaniyaZasedaniya &&
			!object.dataNachalaZasedaniya &&
			!object.dataNachalaRegistratsiiUchastnikov;
	};
	const otkritieregistratsiinazasedanieregionalnogopravleniya = () => {
		return object &&
			!object.dataOkonchaniyaZasedaniya &&
			!object.dataNachalaZasedaniya &&
			!object.dataNachalaRegistratsiiUchastnikov;
	};
	const dokumentprisutstvuyushchienazasedaniiregpravleniya = () => {
		return object &&
			!!object.dataNachalaRegistratsiiUchastnikov &&
			!object.dataOkonchaniyaZasedaniya &&
			!object.dataNachalaZasedaniya;
	};
	const otkritiezasedaniyaregionalnogopravleniya = () => {
		return object &&
			!object.dataOkonchaniyaZasedaniya &&
			!object.dataNachalaZasedaniya &&
			!!object.dataNachalaRegistratsiiUchastnikov;
	};
	const zakritiezasedaniyaregionalnogopravleniya = () => {
		return object &&
			!object.dataOkonchaniyaZasedaniya &&
			!!object.dataNachalaZasedaniya;
	};
	const predlozhenierukiiserdtsa = () => {
		return para?.length <= 0 && pari?.length <= 0;
	};
	const not_predlozhenierukiiserdtsa = () => {
		return para?.length > 0 || pari?.length > 0;
	};
	const xpari = () => {
		return pari?.length > 0;
	};
	const xpara = () => {
		return para?.length > 0;
	};
	//--------------------------------------------------------------------------------------
	const condition = (type) => {
		switch (type.toLowerCase()) {
			case "zayavlenienachlenstvovfederatsii":
				return zayavlenienachlenstvovfederatsii();
			case "not-zayavlenienachlenstvovfederatsii":
				return not_zayavlenienachlenstvovfederatsii();
			case "samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii":
				return samostoyatelnayaregistratsiyavikhodaizchlenstvavfederatsii();
			case "novoezasedaniepravleniyafederatsii":
				return novoezasedaniepravleniyafederatsii();
			case "vpdnovieotdeleniyachleniiliisklyuchenie":
				return vpdnovieotdeleniyachleniiliisklyuchenie();
			case "vpdzasedaniyapravleniyafederatsiitekst":
				return vpdzasedaniyapravleniyafederatsiitekst();
			case "otkritieregistratsiinazasedaniepravleniyafederatsii":
				return otkritieregistratsiinazasedaniepravleniyafederatsii();
			case "dokumentprisutstvuyushchienazasedaniipravleniyafederatsii":
				return dokumentprisutstvuyushchienazasedaniipravleniyafederatsii();
			case "otkritiezasedaniyapravleniyafederatsii":
				return otkritiezasedaniyapravleniyafederatsii();
			case "resheniepovoprosupovestkidnyazasedaniyapravleniyafederatsii":
				return resheniepovoprosupovestkidnyazasedaniyapravleniyafederatsii();
			case "zakritiezasedaniyapravleniyafederatsii":
				return zakritiezasedaniyapravleniyafederatsii();
			case "novoezasedanieregionalnogopravleniya":
				return novoezasedanieregionalnogopravleniya();
			case "vpdnoviepotrebiteliiliisklyuchenie":
				return vpdnoviepotrebiteliiliisklyuchenie();
			case "vpdzasedaniyaregpravleniyatekst":
				return vpdzasedaniyaregpravleniyatekst();
			case "otkritieregistratsiinazasedanieregionalnogopravleniya":
				return otkritieregistratsiinazasedanieregionalnogopravleniya();
			case "dokumentprisutstvuyushchienazasedaniiregpravleniya":
				return dokumentprisutstvuyushchienazasedaniiregpravleniya();
			case "otkritiezasedaniyaregionalnogopravleniya":
				return otkritiezasedaniyaregionalnogopravleniya();
			case "zakritiezasedaniyaregionalnogopravleniya":
				return zakritiezasedaniyaregionalnogopravleniya();
			case "samostoyatelnayaregistratsiyatantsorafederatsii":
				return samostoyatelnayaregistratsiyatantsorafederatsii();
			case "not-samostoyatelnayaregistratsiyatantsorafederatsii":
				return not_samostoyatelnayaregistratsiyatantsorafederatsii();
			case "samostoyatelnayaregistratsiyasudifederatsii":
				return samostoyatelnayaregistratsiyasudifederatsii();
			case "not-samostoyatelnayaregistratsiyasudifederatsii":
				return not_samostoyatelnayaregistratsiyasudifederatsii();
			case "samostoyatelnayaregistratsiyaprepodavatelyafederatsii":
				return samostoyatelnayaregistratsiyaprepodavatelyafederatsii();
			case "not-samostoyatelnayaregistratsiyaprepodavatelyafederatsii":
				return not_samostoyatelnayaregistratsiyaprepodavatelyafederatsii();
			case "samostoyatelnayaregistratsiyaorganizatora":
				return samostoyatelnayaregistratsiyaorganizatora();
			case "not-samostoyatelnayaregistratsiyaorganizatora":
				return not_samostoyatelnayaregistratsiyaorganizatora();
			case "samostoyatelnayaregistratsiyashkolifederatsii":
				return samostoyatelnayaregistratsiyashkolifederatsii();
			case "not-samostoyatelnayaregistratsiyashkolifederatsii":
				return not_samostoyatelnayaregistratsiyashkolifederatsii();
			case "samostoyatelnayaregistratsiyakollektivafederatsii":
				return samostoyatelnayaregistratsiyakollektivafederatsii();
			case "not-samostoyatelnayaregistratsiyakollektivafederatsii":
				return not_samostoyatelnayaregistratsiyakollektivafederatsii();
			case "predlozhenierukiiserdtsa":
				return predlozhenierukiiserdtsa();
			case "not-predlozhenierukiiserdtsa":
				return not_predlozhenierukiiserdtsa();
			case "pari":
				return xpari();
			case "para":
				return xpara();
			default:
				return false;
		}
		return false;
	};
	return (condition(type) === true) ? returnIfTrue : undefined;
}

export default function Rule(props) {
	const { object } = props;

	const chlenFederatsii =  useSelector(getChlenFederatsiiFromRoles(["ЧленФедерации"]));
	const tantsor = useSelector(getTantsorFromRoles(["ТанцорФедерации"]));
	const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"]));
	const para = useSelector(getParaFromRoles(["АдминистраторПарыФедерации"])); // Пара
	const kollektiv = useSelector(getKollektivFromRoles(["АдминистраторКоллективаФедерации"])); // Коллектив
	const prepodavatel = useSelector(getPrepodavatelFromRoles(["ПреподавательФедерации"])); // Преподаватель
	const sudya = useSelector(getSudyaFromRoles(["СудьяФедерации"])); // Судья
	const organizator = useSelector(getOrganizatorFromRoles(["ОрганизаторФедерации", "АдминистраторОрганизатораФедерации"])); // Организатор

	const pari = useSelector(REDUX_Pari.selector.array);
	const zasedanie = useSelector(REDUX_ZasedaniyaPravleniyaFederatsii.selector.object, () => { });

	const MapChildren = (children) => {
		return React.Children.map(children, child => {
			return React.cloneElement(child, { ...props, ...child.props })
		}
		);
	};
	const childrenWithProps = MapChildren(props.children);

	return (
		<>{IFTrue(props.type, true, object, {
			chlenFederatsii,
			tantsor,
			shkola,
			para,
			kollektiv,
			prepodavatel,
			sudya,
			organizator,
			pari,
			zasedanie
		}) == true && childrenWithProps}</>
	);
}

export function RuleContext(props) {
	const { object, context } = props;

	const MapChildren = (children) => {
		return React.Children.map(children, child => {
			return React.cloneElement(child, { ...props, ...child.props })
		}
		);
	};
	const childrenWithProps = MapChildren(props.children);

	return (
		<>{IFTrue(props.type, true, object, context) == true && childrenWithProps}</>
	);
}
